import { useBrand } from '../context/BrandContext';
import FastestFormSettings from './fastestform/Settings';
import AbleSettings from './able/Settings';

export default function Settings() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleSettings /> : <FastestFormSettings />;
}
